import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/20/solid'
import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'
import { Button } from './Button'

const AlertMessage = ({
  message,
  closable,
  cta,
  ctaText,
  type = 'info',
  visible = true,
}: {
  message: any
  type?: 'info' | 'warning'
  closable?: boolean
  cta?: () => void
  ctaText?: string
  visible?: boolean
}) => {
  const [alertVisible, setAlertVisible] = useState(visible)
  if (!alertVisible) return null

  return (
    <div
      className={`rounded-md p-4 ${
        type === 'warning' ? 'bg-orange-50' : 'bg-blue-50'
      }`}
    >
      <div className="flex flex-col items-center sm:flex-row sm:items-center sm:justify-center">
        <div className="flex-shrink-0">
          {type === 'info' && (
            <InformationCircleIcon
              className="h-5 w-5 text-blue-400"
              aria-hidden="true"
            />
          )}
          {type === 'warning' && (
            <ExclamationCircleIcon
              className="h-5 w-5 text-orange-400"
              aria-hidden="true"
            />
          )}
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p
            className={`text-sm ${
              type === 'warning' ? 'text-orange-500' : 'text-toasty-blue-500'
            }`}
          >
            {message}
          </p>
        </div>
        {cta && (
          <div className="ml-4 flex flex-shrink-0 flex-row-reverse items-center">
            <Button onClick={() => cta()}>{ctaText}</Button>
          </div>
        )}
        {closable && (
          <div className="ml-4 flex flex-shrink-0 flex-row-reverse">
            <button
              type="button"
              onClick={() => setAlertVisible(false)}
              className={`inline-flex text-sm ${
                type === 'warning'
                  ? 'text-orange-500 hover:text-orange-600 focus:ring-orange-500'
                  : 'text-toasty-blue-500 hover:text-blue-600 focus:ring-blue-500'
              } focus:outline-none focus:ring-2 focus:ring-offset-2`}
            >
              No Thanks
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default AlertMessage
